export default __webpack_public_path__ + "static/media/gallery-wip-handle-neck_03.65beec39.jpg";